import React from 'react';

const TriangleOverlay = ({score, personal}) => {
    const {wordScore, shapeScore, numberScore} = score;

    // Placing points of score triangle - needs to be on line running between the max and min X/Y values for each point score

    // words coordinate calcs
    const wordPointX = 296;
    const wordPointYMax = 12;
    const wordPointYMin = 280;
    const wordScoreFraction = wordScore / 6;
    const wordPointY = wordPointYMin - ((wordPointYMin - wordPointYMax) * wordScoreFraction);

    // shapes coordinate calcs
    const shapePointXMax = 12;
    const shapePointXMin = 260;
    const shapePointYMax = 503;
    const shapePointYMin = 345;
    const shapeScoreFraction = shapeScore / 6;
    const shapePointX = shapePointXMin - ((shapePointXMin - shapePointXMax) * shapeScoreFraction);
    const shapePointY = shapePointYMin + ((shapePointYMax - shapePointYMin) * shapeScoreFraction);

    // numbers coordinate calcs
    const numberPointXMax = 579;
    const numberPointXMin = 332;
    const numberPointYMax = 503;
    const numberPointYMin = 345;
    const numberScoreFraction = numberScore / 6;
    const numberPointX = numberPointXMin + ((numberPointXMax - numberPointXMin) * numberScoreFraction);
    const numberPointY = numberPointYMin + ((numberPointYMax - numberPointYMin) * numberScoreFraction);

    const points = `${shapePointX} ${shapePointY} ${wordPointX} ${wordPointY} ${numberPointX} ${numberPointY}`

    if (personal) {
        return (
            <div className="score-triangle">
                <svg width="591px" height="515px" viewBox="0 0 591 515">
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.5">
                        <g id="08" fill="#BD0838" fillRule="nonzero" stroke="#BD0838" strokeWidth="3">
                            <polygon id="Path-2" points={points}></polygon>
                        </g>
                    </g>

                    <g id="wordDot" fill="#BD0838" fillRule="nonzero" stroke="#FFFFFF" strokeWidth="3" transform={`translate(${wordPointX}, ${wordPointY})`}>
                        <circle id="Oval" cx="0" cy="0" r={wordScore === 6 ? '10.5' : '7'}></circle>
                    </g>
                    <g id="shapeDot" fill="#BD0838" fillRule="nonzero" stroke="#FFFFFF" strokeWidth="3" transform={`translate(${shapePointX}, ${shapePointY})`}>
                        <circle id="Oval" cx="0" cy="0" r={wordScore === 6 ? '10.5' : '7'}></circle>
                    </g>
                    <g id="numberDot" fill="#BD0838" fillRule="nonzero" stroke="#FFFFFF" strokeWidth="3" transform={`translate(${numberPointX}, ${numberPointY})`}>
                        <circle id="Oval" cx="0" cy="0" r={wordScore === 6 ? '10.5' : '7'}></circle>
                    </g>

                </svg>
            </div>
        );
    } else {
        return (
            <div className="score-triangle">
                <svg width="591px" height="515px" viewBox="0 0 591 515">
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.5">
                        <g id="08" stroke="#fff" strokeWidth="3">
                            <polygon id="Path-2" points={points}> </polygon>
                        </g>
                    </g>
                </svg>
            </div>
        );
    }

};

export default TriangleOverlay;
